import { render } from "./TrayekList.vue?vue&type=template&id=d04b9386&ts=true"
import script from "./TrayekList.vue?vue&type=script&lang=ts"
export * from "./TrayekList.vue?vue&type=script&lang=ts"

import "./TrayekList.vue?vue&type=style&index=0&id=d04b9386&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__